import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
} from "firebase/remote-config";
import type { Prototype } from "@/types/prototype";

const firebaseConfig = {
  apiKey: "AIzaSyBsa25kpyGzqIoe_k6o-acObE2YXNAWTqI",
  authDomain: "howsmom-prototype.firebaseapp.com",
  projectId: "howsmom-prototype",
  storageBucket: "howsmom-prototype.appspot.com",
  messagingSenderId: "313097490241",
  appId: "1:313097490241:web:e0aeb406f22dc66c31dbc0",
};

let app: FirebaseApp | undefined;

function getFirebaseApp(): FirebaseApp {
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
}

export async function fetchPrototypes(): Promise<Prototype[]> {
  const remoteConfig = getRemoteConfig(getFirebaseApp());
  remoteConfig.settings.minimumFetchIntervalMillis = 60000;

  await fetchAndActivate(remoteConfig);

  const raw = getValue(remoteConfig, "prototype_v2").asString();
  const parsed = JSON.parse(raw) as { data: Prototype[] };
  return parsed.data;
}
